export const COUNTRIES = [
  {
    name: 'Afghanistan',
    code: 'AF',
    region: 'Asia',
    subRegion: 'Southern Asia',
  },
  {
    name: 'Åland Islands',
    code: 'AX',
    region: 'Europe',
    subRegion: 'Northern Europe',
  },
  {
    name: 'Albania',
    code: 'AL',
    region: 'Europe',
    subRegion: 'Southern Europe',
  },
  {
    name: 'Algeria',
    code: 'DZ',
    region: 'Africa',
    subRegion: 'Northern Africa',
  },
  {
    name: 'American Samoa',
    code: 'AS',
    region: 'Oceania',
    subRegion: 'Polynesia',
  },
  {
    name: 'Andorra',
    code: 'AD',
    region: 'Europe',
    subRegion: 'Southern Europe',
  },
  {
    name: 'Angola',
    code: 'AO',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Anguilla',
    code: 'AI',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  { name: 'Antarctica', code: 'AQ', region: '', subRegion: '' },
  {
    name: 'Antigua and Barbuda',
    code: 'AG',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Argentina',
    code: 'AR',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  { name: 'Armenia', code: 'AM', region: 'Asia', subRegion: 'Western Asia' },
  {
    name: 'Aruba',
    code: 'AW',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Australia',
    code: 'AU',
    region: 'Oceania',
    subRegion: 'Australia and New Zealand',
  },
  {
    name: 'Austria',
    code: 'AT',
    region: 'Europe',
    subRegion: 'Western Europe',
  },
  { name: 'Azerbaijan', code: 'AZ', region: 'Asia', subRegion: 'Western Asia' },
  {
    name: 'Bahamas',
    code: 'BS',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  { name: 'Bahrain', code: 'BH', region: 'Asia', subRegion: 'Western Asia' },
  {
    name: 'Bangladesh',
    code: 'BD',
    region: 'Asia',
    subRegion: 'Southern Asia',
  },
  {
    name: 'Barbados',
    code: 'BB',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Belarus',
    code: 'BY',
    region: 'Europe',
    subRegion: 'Eastern Europe',
  },
  {
    name: 'Belgium',
    code: 'BE',
    region: 'Europe',
    subRegion: 'Western Europe',
  },
  {
    name: 'Belize',
    code: 'BZ',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Benin',
    code: 'BJ',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Bermuda',
    code: 'BM',
    region: 'Americas',
    subRegion: 'Northern America',
  },
  { name: 'Bhutan', code: 'BT', region: 'Asia', subRegion: 'Southern Asia' },
  {
    name: 'Bolivia (Plurinational State of)',
    code: 'BO',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Bonaire, Sint Eustatius and Saba',
    code: 'BQ',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Bosnia and Herzegovina',
    code: 'BA',
    region: 'Europe',
    subRegion: 'Southern Europe',
  },
  {
    name: 'Botswana',
    code: 'BW',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Bouvet Island',
    code: 'BV',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Brazil',
    code: 'BR',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'British Indian Ocean Territory',
    code: 'IO',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Brunei Darussalam',
    code: 'BN',
    region: 'Asia',
    subRegion: 'South-eastern Asia',
  },
  {
    name: 'Bulgaria',
    code: 'BG',
    region: 'Europe',
    subRegion: 'Eastern Europe',
  },
  {
    name: 'Burkina Faso',
    code: 'BF',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Burundi',
    code: 'BI',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Cabo Verde',
    code: 'CV',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Cambodia',
    code: 'KH',
    region: 'Asia',
    subRegion: 'South-eastern Asia',
  },
  {
    name: 'Cameroon',
    code: 'CM',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Canada',
    code: 'CA',
    region: 'Americas',
    subRegion: 'Northern America',
  },
  {
    name: 'Cayman Islands',
    code: 'KY',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Central African Republic',
    code: 'CF',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Chad',
    code: 'TD',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Chile',
    code: 'CL',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  { name: 'China', code: 'CN', region: 'Asia', subRegion: 'Eastern Asia' },
  {
    name: 'Christmas Island',
    code: 'CX',
    region: 'Oceania',
    subRegion: 'Australia and New Zealand',
  },
  {
    name: 'Cocos (Keeling) Islands',
    code: 'CC',
    region: 'Oceania',
    subRegion: 'Australia and New Zealand',
  },
  {
    name: 'Colombia',
    code: 'CO',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Comoros',
    code: 'KM',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Congo',
    code: 'CG',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Congo, Democratic Republic of the',
    code: 'CD',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Cook Islands',
    code: 'CK',
    region: 'Oceania',
    subRegion: 'Polynesia',
  },
  {
    name: 'Costa Rica',
    code: 'CR',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: "Côte d'Ivoire",
    code: 'CI',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Croatia',
    code: 'HR',
    region: 'Europe',
    subRegion: 'Southern Europe',
  },
  {
    name: 'Cuba',
    code: 'CU',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Curaçao',
    code: 'CW',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  { name: 'Cyprus', code: 'CY', region: 'Asia', subRegion: 'Western Asia' },
  {
    name: 'Czechia',
    code: 'CZ',
    region: 'Europe',
    subRegion: 'Eastern Europe',
  },
  {
    name: 'Denmark',
    code: 'DK',
    region: 'Europe',
    subRegion: 'Northern Europe',
  },
  {
    name: 'Djibouti',
    code: 'DJ',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Dominica',
    code: 'DM',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Dominican Republic',
    code: 'DO',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Ecuador',
    code: 'EC',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  { name: 'Egypt', code: 'EG', region: 'Africa', subRegion: 'Northern Africa' },
  {
    name: 'El Salvador',
    code: 'SV',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Equatorial Guinea',
    code: 'GQ',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Eritrea',
    code: 'ER',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Estonia',
    code: 'EE',
    region: 'Europe',
    subRegion: 'Northern Europe',
  },
  {
    name: 'Eswatini',
    code: 'SZ',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Ethiopia',
    code: 'ET',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Falkland Islands (Malvinas)',
    code: 'FK',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Faroe Islands',
    code: 'FO',
    region: 'Europe',
    subRegion: 'Northern Europe',
  },
  { name: 'Fiji', code: 'FJ', region: 'Oceania', subRegion: 'Melanesia' },
  {
    name: 'Finland',
    code: 'FI',
    region: 'Europe',
    subRegion: 'Northern Europe',
  },
  { name: 'France', code: 'FR', region: 'Europe', subRegion: 'Western Europe' },
  {
    name: 'French Guiana',
    code: 'GF',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'French Polynesia',
    code: 'PF',
    region: 'Oceania',
    subRegion: 'Polynesia',
  },
  {
    name: 'French Southern Territories',
    code: 'TF',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Gabon',
    code: 'GA',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Gambia',
    code: 'GM',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  { name: 'Georgia', code: 'GE', region: 'Asia', subRegion: 'Western Asia' },
  {
    name: 'Germany',
    code: 'DE',
    region: 'Europe',
    subRegion: 'Western Europe',
  },
  {
    name: 'Ghana',
    code: 'GH',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Gibraltar',
    code: 'GI',
    region: 'Europe',
    subRegion: 'Southern Europe',
  },
  {
    name: 'Greece',
    code: 'GR',
    region: 'Europe',
    subRegion: 'Southern Europe',
  },
  {
    name: 'Greenland',
    code: 'GL',
    region: 'Americas',
    subRegion: 'Northern America',
  },
  {
    name: 'Grenada',
    code: 'GD',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Guadeloupe',
    code: 'GP',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  { name: 'Guam', code: 'GU', region: 'Oceania', subRegion: 'Micronesia' },
  {
    name: 'Guatemala',
    code: 'GT',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Guernsey',
    code: 'GG',
    region: 'Europe',
    subRegion: 'Northern Europe',
  },
  {
    name: 'Guinea',
    code: 'GN',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Guinea-Bissau',
    code: 'GW',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Guyana',
    code: 'GY',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Haiti',
    code: 'HT',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Heard Island and McDonald Islands',
    code: 'HM',
    region: 'Oceania',
    subRegion: 'Australia and New Zealand',
  },
  {
    name: 'Holy See',
    code: 'VA',
    region: 'Europe',
    subRegion: 'Southern Europe',
  },
  {
    name: 'Honduras',
    code: 'HN',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  { name: 'Hong Kong', code: 'HK', region: 'Asia', subRegion: 'Eastern Asia' },
  {
    name: 'Hungary',
    code: 'HU',
    region: 'Europe',
    subRegion: 'Eastern Europe',
  },
  {
    name: 'Iceland',
    code: 'IS',
    region: 'Europe',
    subRegion: 'Northern Europe',
  },
  { name: 'India', code: 'IN', region: 'Asia', subRegion: 'Southern Asia' },
  {
    name: 'Indonesia',
    code: 'ID',
    region: 'Asia',
    subRegion: 'South-eastern Asia',
  },
  {
    name: 'Iran (Islamic Republic of)',
    code: 'IR',
    region: 'Asia',
    subRegion: 'Southern Asia',
  },
  { name: 'Iraq', code: 'IQ', region: 'Asia', subRegion: 'Western Asia' },
  {
    name: 'Ireland',
    code: 'IE',
    region: 'Europe',
    subRegion: 'Northern Europe',
  },
  {
    name: 'Isle of Man',
    code: 'IM',
    region: 'Europe',
    subRegion: 'Northern Europe',
  },
  { name: 'Israel', code: 'IL', region: 'Asia', subRegion: 'Western Asia' },
  { name: 'Italy', code: 'IT', region: 'Europe', subRegion: 'Southern Europe' },
  {
    name: 'Jamaica',
    code: 'JM',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  { name: 'Japan', code: 'JP', region: 'Asia', subRegion: 'Eastern Asia' },
  {
    name: 'Jersey',
    code: 'JE',
    region: 'Europe',
    subRegion: 'Northern Europe',
  },
  { name: 'Jordan', code: 'JO', region: 'Asia', subRegion: 'Western Asia' },
  { name: 'Kazakhstan', code: 'KZ', region: 'Asia', subRegion: 'Central Asia' },
  {
    name: 'Kenya',
    code: 'KE',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  { name: 'Kiribati', code: 'KI', region: 'Oceania', subRegion: 'Micronesia' },
  {
    name: "Korea (Democratic People's Republic of)",
    code: 'KP',
    region: 'Asia',
    subRegion: 'Eastern Asia',
  },
  {
    name: 'Korea, Republic of',
    code: 'KR',
    region: 'Asia',
    subRegion: 'Eastern Asia',
  },
  { name: 'Kuwait', code: 'KW', region: 'Asia', subRegion: 'Western Asia' },
  { name: 'Kyrgyzstan', code: 'KG', region: 'Asia', subRegion: 'Central Asia' },
  {
    name: "Lao People's Democratic Republic",
    code: 'LA',
    region: 'Asia',
    subRegion: 'South-eastern Asia',
  },
  {
    name: 'Latvia',
    code: 'LV',
    region: 'Europe',
    subRegion: 'Northern Europe',
  },
  { name: 'Lebanon', code: 'LB', region: 'Asia', subRegion: 'Western Asia' },
  {
    name: 'Lesotho',
    code: 'LS',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Liberia',
    code: 'LR',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  { name: 'Libya', code: 'LY', region: 'Africa', subRegion: 'Northern Africa' },
  {
    name: 'Liechtenstein',
    code: 'LI',
    region: 'Europe',
    subRegion: 'Western Europe',
  },
  {
    name: 'Lithuania',
    code: 'LT',
    region: 'Europe',
    subRegion: 'Northern Europe',
  },
  {
    name: 'Luxembourg',
    code: 'LU',
    region: 'Europe',
    subRegion: 'Western Europe',
  },
  { name: 'Macao', code: 'MO', region: 'Asia', subRegion: 'Eastern Asia' },
  {
    name: 'Madagascar',
    code: 'MG',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Malawi',
    code: 'MW',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Malaysia',
    code: 'MY',
    region: 'Asia',
    subRegion: 'South-eastern Asia',
  },
  { name: 'Maldives', code: 'MV', region: 'Asia', subRegion: 'Southern Asia' },
  {
    name: 'Mali',
    code: 'ML',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  { name: 'Malta', code: 'MT', region: 'Europe', subRegion: 'Southern Europe' },
  {
    name: 'Marshall Islands',
    code: 'MH',
    region: 'Oceania',
    subRegion: 'Micronesia',
  },
  {
    name: 'Martinique',
    code: 'MQ',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Mauritania',
    code: 'MR',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Mauritius',
    code: 'MU',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Mayotte',
    code: 'YT',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Mexico',
    code: 'MX',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Micronesia (Federated States of)',
    code: 'FM',
    region: 'Oceania',
    subRegion: 'Micronesia',
  },
  {
    name: 'Moldova, Republic of',
    code: 'MD',
    region: 'Europe',
    subRegion: 'Eastern Europe',
  },
  { name: 'Monaco', code: 'MC', region: 'Europe', subRegion: 'Western Europe' },
  { name: 'Mongolia', code: 'MN', region: 'Asia', subRegion: 'Eastern Asia' },
  {
    name: 'Montenegro',
    code: 'ME',
    region: 'Europe',
    subRegion: 'Southern Europe',
  },
  {
    name: 'Montserrat',
    code: 'MS',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Morocco',
    code: 'MA',
    region: 'Africa',
    subRegion: 'Northern Africa',
  },
  {
    name: 'Mozambique',
    code: 'MZ',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Myanmar',
    code: 'MM',
    region: 'Asia',
    subRegion: 'South-eastern Asia',
  },
  {
    name: 'Namibia',
    code: 'NA',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  { name: 'Nauru', code: 'NR', region: 'Oceania', subRegion: 'Micronesia' },
  { name: 'Nepal', code: 'NP', region: 'Asia', subRegion: 'Southern Asia' },
  {
    name: 'Netherlands',
    code: 'NL',
    region: 'Europe',
    subRegion: 'Western Europe',
  },
  {
    name: 'New Caledonia',
    code: 'NC',
    region: 'Oceania',
    subRegion: 'Melanesia',
  },
  {
    name: 'New Zealand',
    code: 'NZ',
    region: 'Oceania',
    subRegion: 'Australia and New Zealand',
  },
  {
    name: 'Nicaragua',
    code: 'NI',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Niger',
    code: 'NE',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Nigeria',
    code: 'NG',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  { name: 'Niue', code: 'NU', region: 'Oceania', subRegion: 'Polynesia' },
  {
    name: 'Norfolk Island',
    code: 'NF',
    region: 'Oceania',
    subRegion: 'Australia and New Zealand',
  },
  {
    name: 'North Macedonia',
    code: 'MK',
    region: 'Europe',
    subRegion: 'Southern Europe',
  },
  {
    name: 'Northern Mariana Islands',
    code: 'MP',
    region: 'Oceania',
    subRegion: 'Micronesia',
  },
  {
    name: 'Norway',
    code: 'NO',
    region: 'Europe',
    subRegion: 'Northern Europe',
  },
  { name: 'Oman', code: 'OM', region: 'Asia', subRegion: 'Western Asia' },
  { name: 'Pakistan', code: 'PK', region: 'Asia', subRegion: 'Southern Asia' },
  { name: 'Palau', code: 'PW', region: 'Oceania', subRegion: 'Micronesia' },
  {
    name: 'Palestine, State of',
    code: 'PS',
    region: 'Asia',
    subRegion: 'Western Asia',
  },
  {
    name: 'Panama',
    code: 'PA',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Papua New Guinea',
    code: 'PG',
    region: 'Oceania',
    subRegion: 'Melanesia',
  },
  {
    name: 'Paraguay',
    code: 'PY',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Peru',
    code: 'PE',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Philippines',
    code: 'PH',
    region: 'Asia',
    subRegion: 'South-eastern Asia',
  },
  { name: 'Pitcairn', code: 'PN', region: 'Oceania', subRegion: 'Polynesia' },
  { name: 'Poland', code: 'PL', region: 'Europe', subRegion: 'Eastern Europe' },
  {
    name: 'Portugal',
    code: 'PT',
    region: 'Europe',
    subRegion: 'Southern Europe',
  },
  {
    name: 'Puerto Rico',
    code: 'PR',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  { name: 'Qatar', code: 'QA', region: 'Asia', subRegion: 'Western Asia' },
  {
    name: 'Réunion',
    code: 'RE',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Romania',
    code: 'RO',
    region: 'Europe',
    subRegion: 'Eastern Europe',
  },
  {
    name: 'Russian Federation',
    code: 'RU',
    region: 'Europe',
    subRegion: 'Eastern Europe',
  },
  {
    name: 'Rwanda',
    code: 'RW',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Saint Barthélemy',
    code: 'BL',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    code: 'SH',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Saint Kitts and Nevis',
    code: 'KN',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Saint Lucia',
    code: 'LC',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Saint Martin (French part)',
    code: 'MF',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Saint Pierre and Miquelon',
    code: 'PM',
    region: 'Americas',
    subRegion: 'Northern America',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    code: 'VC',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  { name: 'Samoa', code: 'WS', region: 'Oceania', subRegion: 'Polynesia' },
  {
    name: 'San Marino',
    code: 'SM',
    region: 'Europe',
    subRegion: 'Southern Europe',
  },
  {
    name: 'Sao Tome and Principe',
    code: 'ST',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Saudi Arabia',
    code: 'SA',
    region: 'Asia',
    subRegion: 'Western Asia',
  },
  {
    name: 'Senegal',
    code: 'SN',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Serbia',
    code: 'RS',
    region: 'Europe',
    subRegion: 'Southern Europe',
  },
  {
    name: 'Seychelles',
    code: 'SC',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Sierra Leone',
    code: 'SL',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Singapore',
    code: 'SG',
    region: 'Asia',
    subRegion: 'South-eastern Asia',
  },
  {
    name: 'Sint Maarten (Dutch part)',
    code: 'SX',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Slovakia',
    code: 'SK',
    region: 'Europe',
    subRegion: 'Eastern Europe',
  },
  {
    name: 'Slovenia',
    code: 'SI',
    region: 'Europe',
    subRegion: 'Southern Europe',
  },
  {
    name: 'Solomon Islands',
    code: 'SB',
    region: 'Oceania',
    subRegion: 'Melanesia',
  },
  {
    name: 'Somalia',
    code: 'SO',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'South Africa',
    code: 'ZA',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    code: 'GS',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'South Sudan',
    code: 'SS',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  { name: 'Spain', code: 'ES', region: 'Europe', subRegion: 'Southern Europe' },
  { name: 'Sri Lanka', code: 'LK', region: 'Asia', subRegion: 'Southern Asia' },
  { name: 'Sudan', code: 'SD', region: 'Africa', subRegion: 'Northern Africa' },
  {
    name: 'Suriname',
    code: 'SR',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Svalbard and Jan Mayen',
    code: 'SJ',
    region: 'Europe',
    subRegion: 'Northern Europe',
  },
  {
    name: 'Sweden',
    code: 'SE',
    region: 'Europe',
    subRegion: 'Northern Europe',
  },
  {
    name: 'Switzerland',
    code: 'CH',
    region: 'Europe',
    subRegion: 'Western Europe',
  },
  {
    name: 'Syrian Arab Republic',
    code: 'SY',
    region: 'Asia',
    subRegion: 'Western Asia',
  },
  {
    name: 'Taiwan, Province of China',
    code: 'TW',
    region: 'Asia',
    subRegion: 'Eastern Asia',
  },
  { name: 'Tajikistan', code: 'TJ', region: 'Asia', subRegion: 'Central Asia' },
  {
    name: 'Tanzania, United Republic of',
    code: 'TZ',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Thailand',
    code: 'TH',
    region: 'Asia',
    subRegion: 'South-eastern Asia',
  },
  {
    name: 'Timor-Leste',
    code: 'TL',
    region: 'Asia',
    subRegion: 'South-eastern Asia',
  },
  {
    name: 'Togo',
    code: 'TG',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  { name: 'Tokelau', code: 'TK', region: 'Oceania', subRegion: 'Polynesia' },
  { name: 'Tonga', code: 'TO', region: 'Oceania', subRegion: 'Polynesia' },
  {
    name: 'Trinidad and Tobago',
    code: 'TT',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Tunisia',
    code: 'TN',
    region: 'Africa',
    subRegion: 'Northern Africa',
  },
  { name: 'Türkiye', code: 'TR', region: 'Asia', subRegion: 'Western Asia' },
  {
    name: 'Turkmenistan',
    code: 'TM',
    region: 'Asia',
    subRegion: 'Central Asia',
  },
  {
    name: 'Turks and Caicos Islands',
    code: 'TC',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  { name: 'Tuvalu', code: 'TV', region: 'Oceania', subRegion: 'Polynesia' },
  {
    name: 'Uganda',
    code: 'UG',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Ukraine',
    code: 'UA',
    region: 'Europe',
    subRegion: 'Eastern Europe',
  },
  {
    name: 'United Arab Emirates',
    code: 'AE',
    region: 'Asia',
    subRegion: 'Western Asia',
  },
  {
    name: 'United Kingdom of Great Britain and Northern Ireland',
    code: 'GB',
    region: 'Europe',
    subRegion: 'Northern Europe',
  },
  {
    name: 'United States of America',
    code: 'US',
    region: 'Americas',
    subRegion: 'Northern America',
  },
  {
    name: 'United States Minor Outlying Islands',
    code: 'UM',
    region: 'Oceania',
    subRegion: 'Micronesia',
  },
  {
    name: 'Uruguay',
    code: 'UY',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  { name: 'Uzbekistan', code: 'UZ', region: 'Asia', subRegion: 'Central Asia' },
  { name: 'Vanuatu', code: 'VU', region: 'Oceania', subRegion: 'Melanesia' },
  {
    name: 'Venezuela (Bolivarian Republic of)',
    code: 'VE',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Viet Nam',
    code: 'VN',
    region: 'Asia',
    subRegion: 'South-eastern Asia',
  },
  {
    name: 'Virgin Islands (British)',
    code: 'VG',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Virgin Islands (U.S.)',
    code: 'VI',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
  },
  {
    name: 'Wallis and Futuna',
    code: 'WF',
    region: 'Oceania',
    subRegion: 'Polynesia',
  },
  {
    name: 'Western Sahara',
    code: 'EH',
    region: 'Africa',
    subRegion: 'Northern Africa',
  },
  { name: 'Yemen', code: 'YE', region: 'Asia', subRegion: 'Western Asia' },
  {
    name: 'Zambia',
    code: 'ZM',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
  {
    name: 'Zimbabwe',
    code: 'ZW',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
  },
];
